import { Disclosure, Menu, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import {Bars3Icon, XMarkIcon} from "@heroicons/react/24/outline";
import {Link, useLocation} from "react-router-dom";
import { classNames } from '../utils/helpers';

const Navigation = () => {
  const location = useLocation()

  if (!(location.search && location.search.startsWith("?showNav")))
    return <div></div>

  return (
    <Disclosure as="nav" className="bg-white border-b">
      {({ open }) => (
        <>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <div className="flex h-16 justify-between">
              <div className="flex">
                <div className="hidden sm:flex sm:space-x-4">
                  <Link
                    to={`/${location.search}`}
                    className={classNames(
                      location.pathname === "/" ? "border-b border-gray-500" : "border-b border-white",
                      "inline-flex items-center justify-center px-1 pt-1 text-sm font-medium text-gray-500 hover:text-gray-700"
                    )}>
                    Main
                  </Link>
                  <Link
                    to={`/form/pop-vakuutus${location.search}`}
                    className={classNames(
                      location.pathname === "/form/pop-vakuutus" ? "border-b border-gray-500" : "border-b border-white",
                      "inline-flex items-center px-1 pt-1 text-sm font-medium text-gray-500 hover:text-gray-700"
                    )}>
                    POP Vakuutus
                  </Link>
                </div>
              </div>
              <div className="-mr-2 flex items-center sm:hidden">
                {/* Mobile menu button */}
                <Disclosure.Button className="inline-flex items-center justify-center rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-gray-500">
                  {open ? (
                    <XMarkIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <Bars3Icon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="space-y-1 pt-2 pb-3">
              {/* Current: "bg-gray-50 border-gray-500 text-gray-700", Default: "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700" */}
              <Link
                to="/"
                className="block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700">
                Main
              </Link>
              <Link
                to="/form/pop-vakuutus"
                className="block border-l-4 border-transparent py-2 pl-3 pr-4 text-base font-medium text-gray-500 hover:border-gray-300 hover:bg-gray-50 hover:text-gray-700">
                Form: POP Vakuutus
              </Link>
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}

export default Navigation
